import React, { useState } from 'react';
import { SearchIcon, UserIcon, StarIcon, MapPinIcon, FilterIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface Model {
  id: number;
  name: string;
  location: string;
  specialties: string[];
  rating: number;
  reviewCount: number;
  imageUrl: string;
  portfolioUrl: string;
  availability: string;
  height: string;
  measurements: string;
}
const models: Model[] = [{
  id: 1,
  name: 'Elena Martinez',
  location: 'Miami, FL',
  specialties: ['Romance Covers', 'Editorial', 'Commercial'],
  rating: 4.9,
  reviewCount: 87,
  imageUrl: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e',
  portfolioUrl: '/portfolio/elena-martinez',
  availability: 'Available Now',
  height: '5\'9"',
  measurements: '32-24-34'
}, {
  id: 2,
  name: 'James Wilson',
  location: 'Chicago, IL',
  specialties: ['Fantasy Covers', 'Commercial', 'Fitness'],
  rating: 4.8,
  reviewCount: 62,
  imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d',
  portfolioUrl: '/portfolio/james-wilson',
  availability: 'Available from July',
  height: '6\'1"',
  measurements: '40-32-38'
}, {
  id: 3,
  name: 'Sofia Chen',
  location: 'Vancouver, CA',
  specialties: ['Romance Covers', 'Lifestyle', 'Editorial'],
  rating: 4.7,
  reviewCount: 54,
  imageUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9',
  portfolioUrl: '/portfolio/sofia-chen',
  availability: 'Limited Availability',
  height: '5\'8"',
  measurements: '34-26-36'
}
// Add more models as needed
];
const Models = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('All');
  const specialties = ['All', 'Romance Covers', 'Fantasy Covers', 'Editorial', 'Commercial', 'Lifestyle', 'Fitness'];
  const filteredModels = models.filter(model => {
    const matchesSearch = model.name.toLowerCase().includes(searchTerm.toLowerCase()) || model.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesSpecialty = selectedSpecialty === 'All' || model.specialties.includes(selectedSpecialty);
    return matchesSearch && matchesSpecialty;
  });
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-14767" data-mp="1pac64nxtmlu1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14768" data-mp="1pc6qo156kbxl">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-14769" data-mp="slmomyq3vv8l">
          <UserIcon className="h-12 w-12 text-purple-600 mx-auto mb-4" data-id="element-14770" data-mp="wl5bi01hmge2" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-14771" data-mp="wn87r1t8h5r8">
            Book Cover Models
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-14772" data-mp="16jkzhu57x9jc">
            Find professional models for your next book cover shoot
          </p>
        </div>
        {/* Search and Filter */}
        <div className="mb-8 flex flex-col sm:flex-row gap-4" data-id="element-14773" data-mp="2d216mrksqgm2">
          <div className="relative flex-1" data-id="element-14774" data-mp="2hx6pfhiwjf5x">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-14775" data-mp="6b4tj7gtivbo" />
            <input type="text" placeholder="Search by name or location..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-14776" data-mp="1brw5ssbm5uu" />
          </div>
          <div className="relative" data-id="element-14777" data-mp="3jny5l3adhr5l">
            <FilterIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" data-id="element-14778" data-mp="3eqy9nl78m4s7" />
            <select className="pl-10 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none bg-white" value={selectedSpecialty} onChange={e => setSelectedSpecialty(e.target.value)} data-id="element-14779" data-mp="39t65nstbis7n">
              {specialties.map(specialty => <option key={specialty} value={specialty} data-id="element-14780" data-mp="1b2d2mnrah222">
                  {specialty}
                </option>)}
            </select>
          </div>
        </div>
        {/* Models Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-14781" data-mp="11471i8db3zy9">
          {filteredModels.map(model => <div key={model.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-14782" data-mp="162gz0pmi7cn1">
              <img src={model.imageUrl} alt={model.name} className="w-full h-64 object-cover" data-id="element-14783" data-mp="saakf7z01dpp" />
              <div className="p-6" data-id="element-14784" data-mp="ie7ers4xuwy0">
                <div className="flex justify-between items-start mb-2" data-id="element-14785" data-mp="if8ui9wwg7m2">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-14786" data-mp="nbz4qgm0w8zk">
                    {model.name}
                  </h3>
                  <div className="flex items-center" data-id="element-14787" data-mp="9dj1izndd0m6">
                    <StarIcon className="h-5 w-5 text-yellow-400" data-id="element-14788" data-mp="df4bac4lwys5" />
                    <span className="ml-1 text-sm text-gray-600" data-id="element-14789" data-mp="dgfea9q8a2i7">
                      {model.rating}
                    </span>
                  </div>
                </div>
                <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-14790" data-mp="3ly6bsrro7ylo">
                  <MapPinIcon className="h-4 w-4 mr-1" data-id="element-14791" data-mp="3s1ngfajbtsg" />
                  {model.location}
                </div>
                <div className="mb-4 min-h-[40px]" data-id="element-14792" data-mp="3uvqe8419s0xv">
                  <div className="flex flex-wrap gap-2" data-id="element-14793" data-mp="dowph860ocbh">
                    {model.specialties.map(specialty => <span key={specialty} className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full" data-id="element-14794" data-mp="8qv4ghp162xd">
                        {specialty}
                      </span>)}
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mb-4 text-sm text-gray-600" data-id="element-14795" data-mp="wgfqj9ghdgav">
                  <div data-id="element-14796" data-mp="rhmbhcljph8l">
                    <span className="font-medium" data-id="element-14797" data-mp="ri4csnn2elnd">Height: </span>
                    {model.height}
                  </div>
                  <div data-id="element-14798" data-mp="3l6pz7vghwowg">
                    <span className="font-medium" data-id="element-14799" data-mp="3p9uzdrd3sehx">Status: </span>
                    <span className="text-green-600" data-id="element-14800" data-mp="3p81uohm1w4ck">{model.availability}</span>
                  </div>
                </div>
                <div className="flex gap-2" data-id="element-14801" data-mp="2u9zsxdeewg0">
                  <button className="flex-1 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors" data-id="element-14802" data-mp="2vbnq2fijdf5">
                    Contact
                  </button>
                  <Link to={`/talent/models/${model.id}/portfolio`} className="flex-1 border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50 transition-colors text-center" data-id="element-14803" data-mp="crogmy38hn8u">
                    View Portfolio
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default Models;